module.exports = __webpack_public_path__ + "static/media/coep_dark2.647098ed.png";